





















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class UserMenu extends Vue {
  private logOut(): void {
    localStorage.removeItem('token');
    this.$router.push('/').then(() => (this.$root as any).showSnackbar('Logged Out'));
  }
}
